module.exports = __webpack_public_path__ + "img/xyxf1.dbdb67d8.jpg";